import ACTION_ITEMS from "../actionItems";

export function setSelectedPosition(position) {
  return {
    type: ACTION_ITEMS.PROJECT_BUILDER.SELECTED_POSITION.SET,
    payload: position,
  };
}
